import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../global';

import AttendanceList from './attendance-list';
import EmailAddressInput from './email-address-input';
import moment from 'moment';
import Documents from './documents';
import {
	log_isda_information_to_icms, check_roll_call
} from '../actions/index';

class RollCallHeading extends Component {

	componentDidMount() {
		this.interval = setInterval( () => this.setState( { time: Date.now() } ), 5000 );
	}

	getEnterUserInfoHTML() {

		return (
			<div class="roll-call-admission-container">
				<EmailAddressInput />
			</div>
		);
	}




	getAttendancelHTML() {
		return (<div className="roll-call-admission-container">
				<AttendanceList />
				<Documents />
			</div>
		);
	}

	getCommitteeName( meeting_info ) {

		if ( meeting_info.multi_committee_friendly_name !== '' ) {
			return (
				<h3 class="committee-name">{ meeting_info.multi_committee_friendly_name }</h3>
			);
		}

		let committee_name = [
			(
				<h3 class="committee-name">{ meeting_info.committee_name }</h3>
			)
		];
		if ( meeting_info.multi_committee_names.length > 0 ) {
			committee_name.push( meeting_info.multi_committee_names.map( name => (
				<div class="multi-committee-name">{ name }</div>
			) ) );
		}
		return committee_name;
	}

	render() {
		if ( getErrorType() !== false ) {
			if ( getErrorType() === 'expired' ) {
				return (<div class="document-error">
						The roll call is now closed. Please notify the
						<a href={ 'mailto:' + getContactEmail() }> ISDA Staff Contact</a> if you did attend.
					</div>
				);
			} else {
				return (<div class="document-error">
						An error has occurred. Please contact the
						<a href={ 'mailto:' + getContactEmail() }> ISDA Staff Contact.</a>.
					</div>
				);
			}

		}

		if ( typeof this.props.roll_call_status[ 'time' ] === 'undefined' ) {
			this.props.check_roll_call();
		} else {
			if ( this.props.roll_call_status.data !== 1 ) {
				if ( Date.now() > this.props.roll_call_status[ 'time' ] ) {
					this.props.check_roll_call();
				}

				let meeting_time = getMeetingInfo().timestamp * 1000;
				var diffTime = meeting_time - moment.now();
				var duration = moment.duration( diffTime, 'milliseconds' );
				let time = duration.minutes() + ' minute(s)';
				if ( duration.hours() > 0 ) {
					time = duration.hours() + ' hour(s) and ' + time;
				}
				if ( duration.days() > 0 ) {
					time = duration.days() + ' day(s) ' + time;
				}
				return (<div class="bg-warning">
						The roll call will open in { time }.
					</div>
				);
			} else {
				clearInterval( this.interval );
			}
		}

		var meeting_info = getMeetingInfo();
		let userView = this.getEnterUserInfoHTML();
		if ( this.props.show_attendance === true ) {
			userView = this.getAttendancelHTML();
		}
		if ( isUserLoggedIn() && this.props.show_attendance === false ) {
			this.props.log_isda_information_to_icms( getUserLogIn() );
		}
		return (<div>
				{ this.getCommitteeName( meeting_info ) }
				<h3 class="meeting-name">Meeting: { meeting_info.date }</h3>
				{ userView }
			</div>
		);
	}

}

function mapStateToProps( { show_attendance, roll_call_status, all_companies_for_email } ) {
	return { show_attendance, roll_call_status, all_companies_for_email };
}

export default connect( mapStateToProps, {
	log_isda_information_to_icms,
	check_roll_call
} )( RollCallHeading );